import { render } from "./AlertsMenu.vue?vue&type=template&id=2eca4033&scoped=true"
import script from "./AlertsMenu.vue?vue&type=script&lang=js"
export * from "./AlertsMenu.vue?vue&type=script&lang=js"

import "./AlertsMenu.vue?vue&type=style&index=0&id=2eca4033&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\Documents\\LoesusPedagogia\\ArchiV2\\LP-MyFirstBusiness\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eca4033"]])

export default __exports__